import { Search, MonitorSmartphone, MousePointerClick, ChartLine, Mail, MessageSquare } from "lucide-react";
import { Link } from "@/components/common/Link";
const servicesData = [{
  title: "Missed Call Recovery",
  description: "Our 'Silent Operator' instantly texts back missed calls via WhatsApp, ensuring you never lose a high-value lead while you're on the tools.",
  icon: MessageSquare
}, {
  title: "Unified Trade Inbox",
  description: "Manage WhatsApp, Social Media and Google messages in one place. Stop juggling apps and keep your customer communications professional and organized.",
  icon: MonitorSmartphone
}, {
  title: "Automated Invoicing",
  description: "Generate and send professional invoices instantly. Stop doing admin at 9 PM and get paid faster with our integrated trade payment systems.",
  icon: MousePointerClick
}, {
  title: "Local Map Dominance",
  description: "We optimize your Google Business Profile to ensure your firm appears at the top of local searches in Gloucester and surrounding areas.",
  icon: Search
}, {
  title: "Review Automation",
  description: "Automatically request 5-star reviews from happy customers the moment a job is completed, building your reputation on autopilot.",
  icon: ChartLine
}, {
  title: "Lead Nurturing",
  description: "Strategic SMS and WhatsApp follow-ups that keep your pipeline full and turn one-off emergency calls into lifelong maintenance contracts.",
  icon: Mail
}];
export default function Services() {
  return <section data-section-id="228268" id="services" className="py-24 bg-[#0A0E1A] relative overflow-hidden">
      {}
      <div className="absolute top-0 left-0 w-full h-full pointer-events-none">
        <div className="absolute -top-24 -left-24 w-96 h-96 bg-primary/10 rounded-lg blur-[120px]" />
        <div className="absolute -bottom-24 -right-24 w-96 h-96 bg-primary/10 rounded-lg blur-[120px]" />
      </div>

      <div className="max-w-7xl mx-auto px-6 lg:px-8 relative z-10">
        <div className="mb-16 max-w-2xl mx-auto text-center">
          <h2 className="text-3xl font-extrabold tracking-tight text-primary font-default sm:text-4xl mb-4 uppercase">
            Built For UK Service Professionals
          </h2>
          <p className="text-lg text-white/70 leading-relaxed font-default">
            The Silent Operator system automates the admin, invoicing, and lead recovery that tradesmen hate doing at night.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-12 gap-y-16">
          {servicesData.map((service, i) => {
          const Icon = service.icon;
          return <div key={i} data-index={i} className="flex flex-col backdrop-blur-md bg-white/5 border border-white/10 p-8 rounded-lg shadow-lg transition-all hover:border-primary/50">
                <div className="mb-6 inline-flex size-12 items-center justify-center rounded-lg bg-primary/10 border border-primary/20">
                  <Icon className="size-6 text-primary" aria-hidden="true" />
                </div>
                <h3 className="text-xl font-bold text-white font-default mb-3 uppercase tracking-wide">
                  {service.title}
                </h3>
                <p className="text-base text-white/60 leading-relaxed font-default">
                  {service.description}
                </p>
              </div>;
        })}
        </div>

        <div className="mt-20 flex justify-center">
          <Link to="/PricingPage">
            <button className="group relative inline-flex items-center gap-2 bg-primary px-8 py-4 text-sm font-bold uppercase tracking-widest text-primary-foreground transition-all hover:translate-x-[-2px] hover:translate-y-[-2px] active:translate-x-0 active:translate-y-0 rounded-lg font-default cursor-pointer">
              Secure Founder Spot
              <svg className="size-4 transition-transform group-hover:translate-x-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
              </svg>
            </button>
          </Link>
        </div>
      </div>
    </section>;
}